<template>
  <tr class="text-left h-12.5">
    <slot />
  </tr>
</template>
